import { MeditationNode } from 'src/generated/webapp_gql';

const resolvers = {
    MeditationNode: {
        isCompleted: (node: MeditationNode): boolean => {
            return node?.meditationProgress?.some(progress => progress.completedAt) || false;
        },
        isStarted: (node: MeditationNode): boolean => {
            return node?.meditationProgress?.some(progress => progress.startedAt) || false;
        },
    },
};

export default resolvers;
